import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../Modal';
import Share from '../../../Share';
import AddToFavoritesBtn from '../../../AddToFavoritesBtn';

import './style.scss';

const ModalAudioOptions = ({
  children,
  favorite,
  share,
  onClose,
  onClickFavorite
}) => (
  <Modal onClose={onClose} className="ModalProgram">
    <ul className="list-program">
      <li className="item item--program">{children}</li>
      <li className="item item--add">
        <AddToFavoritesBtn
          className="add-favorites"
          isFavorite={favorite}
          onClick={() => onClickFavorite()}
        />
        <span className="mt-5 ml-10">
          {favorite ? 'Quitar de' : 'Añadir a'} mi lista
        </span>
      </li>
      {share && (
        <li className="item item--social">
          <span className="txt-share">Compartir</span>
          <Share
            className="share-modal"
            shareTitle={share.shareTitle}
            link={share.link}
          />
        </li>
      )}
    </ul>
  </Modal>
);

ModalAudioOptions.propTypes = {
  children: PropTypes.node,
  favorite: PropTypes.bool,
  share: PropTypes.shape({
    shareTitle: PropTypes.string,
    link: PropTypes.string
  }),
  onClose: PropTypes.func,
  onClickFavorite: PropTypes.func
};

ModalAudioOptions.defaultProps = {
  children: null,
  favorite: false,
  share: null,
  onClose: null,
  onClickFavorite: null
};

export default ModalAudioOptions;
